import React from 'react';
import { useDispatch } from 'react-redux';
import {
  decreaseFromCart,
  increaseFromCart,
  removeCart,
} from '../redux/cart/actions';
import {
  decreaseProduct,
  increaseProduct,
  increaseProductByValue,
} from '../redux/products/actions';

const CartCard = ({ item }) => {
  const { image, name, category, price, quantity, productId, id, originalQty } =
    item;

  const dispatch = useDispatch();

  const handleDecrement = () => {
    dispatch(decreaseFromCart(id));
    dispatch(increaseProduct(productId));
  };

  const handleIncrement = () => {
    dispatch(increaseFromCart(id));
    dispatch(decreaseProduct(productId));
  };

  const handleRemove = () => {
    dispatch(removeCart(id));
    dispatch(increaseProductByValue(productId, quantity));
  };

  return (
    <div className="cartCard">
      <div className="flex items-center col-span-6 space-x-6">
        {/* <!-- cart image --> */}
        <img className="lws-cartImage" src={image} alt="product" />
        {/* <!-- cart item info --> */}
        <div className="space-y-2">
          <h4 className="lws-cartName">{name}</h4>
          <p className="lws-cartCategory">{category}</p>
          <p>
            BDT <span className="lws-cartPrice">{price}</span>
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
        {/* <!-- amount buttons --> */}
        <div className="flex items-center space-x-4">
          <button
            className="lws-incrementQuantity"
            onClick={handleIncrement}
            disabled={quantity === originalQty}
          >
            <i className="text-lg fa-solid fa-plus"></i>
          </button>
          <span className="lws-cartQuantity">{quantity}</span>
          <button
            className="lws-decrementQuantity"
            onClick={handleDecrement}
            disabled={quantity === 1}
          >
            <i className="text-lg fa-solid fa-minus"></i>
          </button>
        </div>
        {/* <!-- price --> */}
        <p className="text-lg font-bold">
          BDT <span className="lws-calculatedPrice">{quantity * price}</span>
        </p>
      </div>
      {/* <!-- delete button --> */}
      <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
        <button className="lws-removeFromCart" onClick={handleRemove}>
          <i className="text-lg text-red-400 fa-solid fa-trash"></i>
        </button>
      </div>
    </div>
  );
};

export default CartCard;
